export default __webpack_public_path__ + "static/media/push38.104bb555.gif";